<div class="calenderMobile" *ngIf="sharedService.screenWidth < 650">
  <div class="container">
    <div class="calenderMobile_header">
      <!-- List Buttons -->

      <div class="header_closeBtn">
        <button (click)="backToSearchBox()">
          {{ "searchbox.close" | translate }}
        </button>
      </div>
    </div>
    <!-- Dates -->
    <div *ngIf="showPicker">
      <!-- RoundTrip DatePicker -->
      <div
        class="calenderMobile_datepicker"
        *ngIf="
          flightType == 'RoundTrip' &&
            sharedService.roundTripDatepickerMobileView;
          else elseCondition
        "
      >
        <ngb-datepicker
          #dp
          [displayMonths]="12"
          [dayTemplate]="t"
          outsideDays="hidden"
          [firstDayOfWeek]="7"
          (dateSelect)="onDateSelectionRound($event)"
          [startDate]="minReturnDate"
          firstDate="startDateValue"
          [minDate]="minReturnDate"
        >
        </ngb-datepicker>
        <ng-template
          #t
          let-date
          let-focused="focused"
          (click)="$event.stopPropagation()"
        >
          <span
            class="custom-day"
            [class.focused]="focused"
            [class.range]="isRangeR(date)"
            [class.faded]="isHoveredR(date) || isInsideR(date)"
            (mouseenter)="hoveredDate = date"
            (mouseleave)="hoveredDate = null"
            >{{ date.day }}
          </span>
        </ng-template>
      </div>

      <!-- One Way, Multicity Datepicker-->
      <ng-template #elseCondition>
        <div class="calenderMobile_datepicker">
          <ngb-datepicker
            #dp
            [displayMonths]="12"
            [dayTemplate]="t"
            outsideDays="hidden"
            [firstDayOfWeek]="7"
            [startDate]="retStartDate()"
            firstDate="retStartDate()"
            [minDate]="minDate"
            (restoreFocus)="(true)"
          >
          </ngb-datepicker>
          <ng-template #t let-date let-focused="focused">
            <span
              (click)="onDateSelection(date)"
              (closed)="onDateSelection(date)"
              class="custom-day"
              [class.focused]="focused"
              [class.active]="true"
              [class.range]="isRange(date)"
              [class.value]="isRange(date)"
              [class.faded]="isHovered(date) || isInside(date)"
              [class.disabled]="isDisabled(date)"
              >{{ date.day }}
            </span>
          </ng-template>
        </div>
      </ng-template>
    </div>
    <!-- 
    <div class="confirmBtn">
      <button (click)="confirmDate()">
        {{ "searchbox.confirm" | translate }}
      </button>
    </div> -->
  </div>
</div>
